import { filtersConfig } from '@/common/static_data';
import type { FilterConfigShape } from '@/pages/Shipments/ControlTower/types';

// GxP Reports reuses the shipment filter groups but swaps "Alerts & Risk" for
// a "Triage" group (Excursions / Data) and drops "Linked shipments", which
// don't apply to this GxP report.
export const gxpFiltersConfig: FilterConfigShape = {
  topLevelFilters: filtersConfig.topLevelFilters,
  groupedFilters: filtersConfig.groupedFilters.map((group) => {
    if (group.group === 'Alerts & Risk') {
      return {
        group: 'Triage',
        items: [
          { id: 101, key: 'excursions', label: 'Excursions' },
          { id: 102, key: 'data', label: 'Data' },
        ],
      };
    }

    if (group.group === 'Shipment') {
      return {
        ...group,
        items: group.items.filter((item) => item.key !== 'link_code'),
      };
    }

    return group;
  }),
};
